<style>
    /* Keep all your existing styles */
    .custom-tooltip {
        position: relative;
        display: inline-block;
        cursor: pointer;
    }

    .custom-tooltiptext {
        visibility: hidden;
        width: 200px;
        background-color: #fff8ed;
        color: #514d6a;
        font-family: Calibri, sans-serif;
        font-size: 13px;
        border: 1px solid #f39834;
        border-radius: 6px;
        padding: 5px;
        position: absolute;
        left: 25px;
        z-index: 1;
    }

    .custom-tooltip:hover .custom-tooltiptext {
        visibility: visible;
    }

    .lastLoginTime {
        font-size: 12px;
        display: none
    }

    .lastLoginTime a {
        font-size: 14px;
    }

    .m-t-0 {
        margin-top: 0px;
    }

    .cat__menu-left__logo {
        background-color: #f9f9f9 !important;
     
    }

    .sidebar-footer {
        margin-top: auto;
        padding: 16px 24px 24px;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        font-size: 11px;
        color: rgba(255, 255, 255, 0.85);
    }

    .sidebar-footer__copyright {
        margin-bottom: 4px;
    }

    .sidebar-footer__version {
        font-weight: 500;
        color: rgba(255, 255, 255, 0.9);
    }

    .customMenuLeftInActive>a {
        font-size: 15px !important;
        font-weight: 500;
        background-color: transparent;
        color: #ffffff;
        position: relative;
        min-height: 3.21rem;
        padding: 0.85rem 3.57rem 0.85rem 1.42rem;
        display: block;
        cursor: pointer !important;
        text-align: -webkit-match-parent;
        list-style: none;
        font-family: 'Segoe UI', Arial, sans-serif !important;
        line-height: 1.5;
    }

    .material-symbols-outlined {
        vertical-align: middle;
        font-size: 20px !important;
        color: #ffffff;
        line-height: 1;
        font-family: 'Material Symbols Outlined' !important;
    }

    .customMenuLeftInActive:hover>a {
        font-size: 15px !important;
        font-weight: 500;
        background: rgba(255, 255, 255, 0.15) !important;
        color: #FFF !important;
        position: relative;
        min-height: 3.21rem;
        padding: 0.85rem 3.57rem 0.85rem 1.42rem;
        display: block;
        cursor: pointer !important;
        text-align: -webkit-match-parent;
        list-style: none;
        font-family: 'Segoe UI', Arial, sans-serif !important;
        line-height: 1.5;
    }

    .customMenuLeftInActive>a::after {
        border-width: 0.35rem 0.35rem 0.35rem 0.35rem;
        border-color: #ec0c0c00 #06828000 #0014ff00 rgba(255, 255, 255, 0.7);
        box-sizing: inherit;
        display: block;
        content: '';
        border-style: solid;
        position: absolute;
        top: 20px;
        right: 2rem;
    }

    .customMenuLeftInActive:hover>a::after {
        border-width: 0.35rem 0.35rem 0.35rem 0.35rem;
        border-color: #ec0c0c00 #06828000 #0014ff00 #FFF;
        box-sizing: inherit;
        display: block;
        content: '';
        border-style: solid;
        position: absolute;
        top: 20px;
        right: 2rem;
    }

    .customMenuLeftActive>a {
        font-size: 15px !important;
        font-weight: 500;
        background: rgba(255, 255, 255, 0.2);
        color: #ffffff;
        position: relative;
        min-height: 3.21rem;
        padding: 0.85rem 3.57rem 0.85rem 1.42rem;
        display: block;
        cursor: pointer !important;
        text-align: -webkit-match-parent;
        list-style: none;
        font-family: 'Segoe UI', Arial, sans-serif !important;
        line-height: 1.5;
        transition: all 0.2s linear;
    }

    .customMenuLeftActive>a::after {
        border-width: 0.35rem 0.35rem 0.35rem 0.35rem;
        border-color: #ec0c0c00 #06828000 #0014ff00 #FFF;
        transform: rotate(-90deg);
        box-sizing: inherit;
        display: block;
        content: '';
        border-style: solid;
        position: absolute;
        top: 20px;
        right: 2rem;
    }

    /* Standardize all menu items font and size */
    .cat__menu-left__item > a {
        font-size: 15px !important;
        font-family: 'Segoe UI', Arial, sans-serif !important;
    }

    .cat__menu-left__item > a.subitem {
        font-size: 15px !important;
        font-family: 'Segoe UI', Arial, sans-serif !important;
    }

    .cat__menu-left__item--active > a {
        font-size: 15px !important;
        font-family: 'Segoe UI', Arial, sans-serif !important;
    }

    .cat__menu-left__item:hover > a {
        font-size: 15px !important;
        font-family: 'Segoe UI', Arial, sans-serif !important;
    }

    /* Standardize all icons size */
    .cat__menu-left__item > a .material-symbols-outlined,
    .cat__menu-left__item > a .material-symbols-outlined {
        font-size: 20px !important;
        font-family: 'Material Symbols Outlined' !important;
    }

    @media screen and (max-width:991px) {
        .lastLoginTime {
            display: block;
        }
    }
</style>

<nav class="cat__menu-left">
    <div class="cat__menu-left__lock cat__menu-left__action--menu-toggle" >
        <i class="fa fa-times closebtn" (click)="toggleNav()" (keydown.enter)="toggleNav()" (keydown.space)="toggleNav(); $event.preventDefault()" tabindex="0" role="button" aria-hidden="true"></i>
    </div>
    <div class="cat__menu-left__logo">
        <a href="/#/structure/(structure-outlet:dashboards/alpha)">
            <img src="../../../assets/modules/dummy-assets/common/img/GovEVA.png" style="max-height: 3.9rem;"
                alt="DigiCompany" />
        </a>
    </div>
    <div class="cat__menu-left__inner">
        <ul class="cat__menu-left__list cat__menu-left__list--root m-t-0">
            <li class="cat__menu-left__item cat__menu-left--colorful--secondary lastLoginTime">
                <a href="javascript:void();">
                    <b>Last Login: {{lastLoginDetails.lastLoginAttempt ? "Successful" : "UnSuccessful"}} on {{lastLoginDetails.lastloginTime ? (lastLoginDetails.lastloginTime | date :'dd-MM-yyyy hh:mm:ss a') : ""}}</b>
                </a>
            </li>

            <!-- Master Menu -->
            <li class="cat__menu-left__item cat__menu-left__submenu"
                [ngClass]="{'customMenuLeftInActive': menuName !== 'Master', 'customMenuLeftActive': menuName === 'Master'}"
                *ngIf="masterMenuEnable && FinalMenu.Master">
                <a (click)="activeMenu('Master')" href="javascript: void(0);">
                    <span class="material-symbols-outlined">manage_accounts</span>
                    Masters
                </a>
                <ul class="cat__menu-left__list sub-menu-list">
                    <!-- Keep all Master menu items here -->
                    <li class="cat__menu-left__item"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Company'}"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'CompanyMaster'}">
                        <a [routerLink]="[{outlets:{'structure-outlet':'companymaster'}}]" class="subitem"
                            (click)="activeMenu('Company')">
                            <span class="form-control-label custom-tooltip">
                                Company
                                <span class="custom-tooltiptext">
                                    A single source of common business data that will be across application for an
                                    entire enterprise
                                </span>
                            </span>
                        </a>
                    </li>
                    <li class="cat__menu-left__item" [ngClass]="{'cat__menu-left__item--active': menuName === 'Role'}"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'RoleMaster'}"
                        *ngIf="!isUPSILiteActive">
                        <a [routerLink]="[{outlets:{'structure-outlet':'role-master/roleMaster'}}]" class="subitem"
                            (click)="activeMenu('Role')">

                            <span class="form-control-label custom-tooltip">
                                Roles
                                <span class="custom-tooltiptext" style="left: 0;top: 34px;">
                                    Different employees of the company who will be using the DigiCompany software and
                                    extent
                                    of powers assigned to them accordingly.
                                </span>
                            </span>
                        </a>
                    </li>
                    <li class="cat__menu-left__item" [ngClass]="{'cat__menu-left__item--active': menuName === 'User'}"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'UserMaster'}">
                        <a [routerLink]="[{outlets:{'structure-outlet':'userMaster/userManagement'}}]" class="subitem"
                            (click)="activeMenu('User')">

                            <span class="form-control-label custom-tooltip">
                                Users
                                <span class="custom-tooltiptext" style="left: 0;top: 34px;">
                                    List of different employees of the company who will be the end users of the
                                    software/application.
                                </span>
                            </span>
                        </a>
                    </li>
                    <li class="cat__menu-left__item"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Individual Meeting'}"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'individual-meeting'}">
                        <a [routerLink]="[{outlets:{'structure-outlet':'individual-meeting'}}]" class="subitem"
                            (click)="activeMenu('Individual Meeting')">

                            <span class="form-control-label custom-tooltip">
                                Users
                                <span class="custom-tooltiptext" style="left: 0;top: 34px;">
                                    List of different employees of the company who will be the end users of the
                                    software/application.
                                </span>
                            </span>
                        </a>
                    </li>

                    <li class="cat__menu-left__item" (click)="activeMenu('upsimaster')"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'upsimaster'}"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'UPSI Master'}" *ngIf="!isUPSILiteActive">
                        <!-- <a href="{{menuLinkObject.UPSIMaster}}" class="subitem"> -->
                        <a [routerLink]="[{outlets:{'structure-outlet':'upsimaster'}}]" class="subitem"
                            (click)="activeMenu('UPSI Master')">

                            UPSI Master
                        </a>
                    </li>

                    <li class="cat__menu-left__item" (click)="activeMenu('upsimaster')"
                    [ngClass]="{'cat__menu-left__item--active': menuName === 'upsimaster'}"
                    [appHasPermission]="{'Url': '', 'method':'', 'menu': 'UPSI Master'}" *ngIf="isUPSILiteActive">
                    <!-- <a href="{{menuLinkObject.UPSIMaster}}" class="subitem"> -->
                    <a [routerLink]="[{outlets:{'structure-outlet':'upsimaster'}}]" class="subitem"
                        (click)="activeMenu('UPSI Master')">

                        Type of UPSI
                    </a>
                </li>
                    
                    <li class="cat__menu-left__item" (click)="activeMenu('upsiparam')"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'upsiparam'}"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'UPSI Parameter'}">
                        <!-- <a  href="{{menuLinkObject.UPSIParam}}" class="subitem"> -->
                        <a [routerLink]="[{outlets:{'structure-outlet':'upsiparam'}}]" class="subitem"
                            (click)="activeMenu('UPSI Param')">
                            UPSI Parameter
                        </a>
                    </li>
                    <li class="cat__menu-left__item"
                    [ngClass]="{'cat__menu-left__item--active': menuName === 'upsiSharer'}"
                    [appHasPermission]="{'Url': '', 'method':'', 'menu': 'UPSI Sharer'}"
                    *ngIf="!isUPSILiteActive">
                    <a [routerLink]="[{outlets:{'structure-outlet':'userMaster/upsisharer'}}]" class="subitem">
                        <span class="form-control-label custom-tooltip">
                            UPSI Sharer
                            <span class="custom-tooltiptext">
                                Add and manage users or employees who are responsible for sharing Unpublished Price
                                Sensitive Information (UPSI) within the organization.
                            </span>
                        </span>
                    </a>
                </li>

                <li class="cat__menu-left__item"
                [ngClass]="{'cat__menu-left__item--active': menuName === 'upsiRecipient'}"
                [appHasPermission]="{'Url': '', 'method':'', 'menu': 'UPSI Recipient'}"
                *ngIf="!isUPSILiteActive">
                <a [routerLink]="[{outlets:{'structure-outlet':'userMaster/upsirecipient'}}]" class="subitem">


                    <span class="form-control-label custom-tooltip">
                        UPSI Recipient
                        <span class="custom-tooltiptext">
                            Track and manage users or external parties who receive Unpublished Price Sensitive
                            Information (UPSI) for compliance purposes
                        </span>
                    </span>
                </a>
            </li>
                    <li class="cat__menu-left__item"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Company Financial Details'}"
                        *ngIf="(isAllConfig || isGovevaConfig || isPSSConfig) && (!MeetingMakerWithoutAgenda && !MeetingMakerWithAgenda) && !isUPSILiteActive"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'CompanyFinancialDetails'}">
                        <!-- <a href="{{menuLinkObject.CompanyFinancialDetails}}" class="subitem" (click)="activeMenu('Company Financial Details')"> -->
                        <a [routerLink]="[{outlets:{'structure-outlet':'company/financeDetails'}}]" class="subitem"
                            (click)="activeMenu('Company Financial Details')">

                            Company Financial Details
                        </a>
                    </li>
                    <li class="cat__menu-left__item"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Committee'}"
                        *ngIf="(isAllConfig || isGovevaConfig || isPSSConfig) && !isUPSILiteActive"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Committee'}">
                        <!-- <a href="{{menuLinkObject.Commitee}}" class="subitem" (click)="activeMenu('Committee')"> -->
                        <a [routerLink]="[{outlets:{'structure-outlet':'committee'}}]" class="subitem"
                            (click)="activeMenu('Committee')">

                            Committee
                        </a>
                    </li>

                    <!-- <li class="cat__menu-left__item" (click)="activeMenu('branch')" *ngIf="(isAllConfig || isGovevaConfig || isPSSConfig)  && (!MeetingMakerWithoutAgenda && !MeetingMakerWithAgenda)" [ngClass]="{'cat__menu-left__item--active': menuName === 'branch'}">
                      
                            <a [routerLink]="[{outlets:{'structure-outlet':'branch'}}]" class="subitem">

                            Branch
                        </a>
                    </li> -->

                    <!-- <li class="cat__menu-left__item" (click)="activeMenu('department')"  [ngClass]="{'cat__menu-left__item--active': menuName === 'department'}">
                        
                            <a [routerLink]="[{outlets:{'structure-outlet':'department'}}]" class="subitem">

                            Department
                        </a>
                    </li> -->

                    <li class="cat__menu-left__item" (click)="activeMenu('Tag')"
                        *ngIf="(isAllConfig || isGovevaConfig || isPSSConfig)  && (!MeetingMakerWithoutAgenda && !MeetingMakerWithAgenda) && !isUPSILiteActive"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Tag'}"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Tag'}">
                        <!-- <a href="{{menuLinkObject.Group}}" class="subitem"> -->
                        <a [routerLink]="[{outlets:{'structure-outlet':'tag'}}]" class="subitem">
                            Tag
                        </a>
                    </li>
                    <li class="cat__menu-left__item"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Category'}"
                        *ngIf="(isAllConfig || isGovevaConfig || isPSSConfig) && !MeetingMakerWithoutAgenda && !isUPSILiteActive"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Category'}">
                        <!-- <a href="{{menuLinkObject.AgendaCategories}}" class="subitem" (click)="activeMenu('Category')"> -->
                        <a [routerLink]="[{outlets:{'structure-outlet':'category'}}]" class="subitem"
                            (click)="activeMenu('Category')">

                            Agenda Categories
                        </a>
                    </li>

                    <!-- <li class="cat__menu-left__item" (click)="activeMenu('userteam')" *ngIf="(isAllConfig || isGovevaConfig || isPSSConfig)  && (!MeetingMakerWithoutAgenda && !MeetingMakerWithAgenda)" [ngClass]="{'cat__menu-left__item--active': menuName === 'userteam'}">
                        
                            <i class="cat__menu-left__icon fa fa-tags"></i>
                            <a [routerLink]="[{outlets:{'structure-outlet':'user/team'}}]" class="subitem">

                            User Team Master
                        </a>
                    </li> -->

                    <li class="cat__menu-left__item"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Holiday'}"
                        *ngIf="(isAllConfig || isGovevaConfig || isPSSConfig) && (!MeetingMakerWithoutAgenda && !MeetingMakerWithAgenda) && !isUPSILiteActive"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Holiday'}">
                        <!-- <a href="{{menuLinkObject.Holiday}}" class="subitem" (click)="activeMenu('Holiday')"> -->
                        <a [routerLink]="[{outlets:{'structure-outlet':'holiday'}}]" class="subitem"
                            (click)="activeMenu('Holiday')">

                            Holiday
                        </a>
                    </li>
                    <li class="cat__menu-left__item"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'agendaGroup'}"
                        *ngIf="(isAllConfig || isGovevaConfig || isPSSConfig) && !MeetingMakerWithoutAgenda && !isUPSILiteActive"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'AgendaGroup'}">
                        <!-- <a href="{{menuLinkObject.agendaGroup}}" class="subitem" (click)="activeMenu('agendaGroup')"> -->
                        <a [routerLink]="[{outlets:{'structure-outlet':'agendaGroup'}}]" class="subitem"
                            (click)="activeMenu('agendaGroup')">

                            Agenda Group
                        </a>
                    </li>
                    <li class="cat__menu-left__item"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'defaultMeeting'}"
                        *ngIf="(isAllConfig || isGovevaConfig || isPSSConfig) && !MeetingMakerWithoutAgenda && !isUPSILiteActive"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'DefaultMeeting'}">
                        <!-- <a href="{{menuLinkObject.defaultMeeting}}" class="subitem" (click)="activeMenu('defaultMeeting')"> -->
                        <a [routerLink]="[{outlets:{'structure-outlet':'defaultMeeting'}}]" class="subitem"
                            (click)="activeMenu('defaultMeeting')">

                            Default Meeting Details



                        </a>
                    </li>
                    <li class="cat__menu-left__item"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'NCD Document'}"
                        *ngIf="!isSuperAdmin && (isNCDConfig ) && !isUPSILiteActive">
                        <!-- <a class="subitem" href="{{menuLinkObject.NCDDocumentGenerationSetup}}"> -->
                        <a [routerLink]="[{outlets:{'structure-outlet':'ncd/document/generation/mster/setup'}}]"
                            class="subitem">

                            <span class="form-control-label custom-tooltip">
                                NCD Document Generation Master Setup
                            </span>
                        </a>
                    </li>


                    <li class="cat__menu-left__item" (click)="activeMenu('Meetings')"
                        *ngIf="(isAllConfig || isGovevaConfig || isPSSConfig)  && (!MeetingMakerWithoutAgenda && !MeetingMakerWithAgenda) && !isUPSILiteActive"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Meetings'}"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Meetings'}">
                        <!-- <a href="{{menuLinkObject.MeetingEmailTemplates}}" class="subitem"> -->
                        <a [routerLink]="[{outlets:{'structure-outlet':'emailReminderTemplates/Meeting'}}]"
                            class="subitem" (click)="activeMenu('agendaGroup')">

                            Meeting Email Templates
                        </a>
                    </li>

                    <li class="cat__menu-left__item" (click)="activeMenu('TaskAndActivities')"
                        *ngIf="(isAllConfig || isGovevaConfig || isPSSConfig)  && (!MeetingMakerWithoutAgenda && !MeetingMakerWithAgenda) && !isUPSILiteActive"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Task and Activities'}"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'LibraryTask'}">
                        <!-- <a href="{{menuLinkObject.emailReminderTemplatesTask}}" class="subitem"> -->
                        <a [routerLink]="[{outlets:{'structure-outlet':'emailReminderTemplates/Task'}}]" class="subitem"
                            (click)="activeMenu('agendaGroup')">

                            Task Email Templates
                        </a>
                    </li>

                    <li class="cat__menu-left__item" (click)="activeMenu('Email Template UPSI')"
                        *ngIf="(isAllConfig || isGovevaConfig || isPSSConfig)  && (!MeetingMakerWithoutAgenda && !MeetingMakerWithAgenda)"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Email Template UPSI'}"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Email Template'}">
                        <!-- <a href="{{menuLinkObject.emailReminderTemplatesUpsi}}" class="subitem"> -->
                        <a [routerLink]="[{outlets:{'structure-outlet':'emailReminderTemplates/Upsi'}}]" class="subitem"
                            (click)="activeMenu('agendaGroup')">

                            UPSI Email Templates
                        </a>
                    </li>

                    <li class="cat__menu-left__item" (click)="activeMenu('ncd')"
                        *ngIf="(isAllConfig || isGovevaConfig || isPSSConfig)  && (!MeetingMakerWithoutAgenda && !MeetingMakerWithAgenda) && (!isSuperAdmin && (isNCDConfig ) && ncdMenu) && !isUPSILiteActive"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'ncd'}">
                        <!-- <a href="{{menuLinkObject.emailReminderTemplatesNcd}}" class="subitem"> -->
                        <a [routerLink]="[{outlets:{'structure-outlet':'emailReminderTemplates/Ncd'}}]" class="subitem"
                            (click)="activeMenu('agendaGroup')">

                            NCD Email Templates
                        </a>
                    </li>

                    <li class="cat__menu-left__item" (click)="activeMenu('Meetings')"
                        *ngIf="(isAllConfig || isGovevaConfig || isPSSConfig)  && (!MeetingMakerWithoutAgenda && !MeetingMakerWithAgenda) && !isUPSILiteActive"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Meetings'}"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Meetings'}">
                        <!-- <a href="{{menuLinkObject.ComplianceCertificateEmailTemplates}}" class="subitem"> -->
                        <a [routerLink]="[{outlets:{'structure-outlet':'emailReminderTemplates/ComplianceCertificate'}}]"
                            class="subitem" (click)="activeMenu('agendaGroup')">

                            Compliance Certificate Email Templates
                        </a>
                    </li>

                </ul>
            </li>

             <!-- Compliance -->
             <li class="cat__menu-left__item cat__menu-left__submenu"
             [ngClass]="{'customMenuLeftInActive': menuName !== 'Compliance', 'customMenuLeftActive': menuName === 'Compliance'}"
             *ngIf="complianceMenuEnable && (isAllConfig || isPSSConfig) && FinalMenu.Complaince && !isUPSILiteActive">

             <a (click)="activeMenu('Compliance')" href="javascript: void(0);">
                 <span class="material-symbols-outlined">balance</span>
                 Compliance & Board
             </a>

             <ul class="cat__menu-left__list sub-menu-list">
                 <!-- Meetings -->
                 <li class="cat__menu-left__item"
                     [ngClass]="{'cat__menu-left__item--active': menuName === 'Meetings'}"
                     [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Meetings'}">
                     <a [routerLink]="[{outlets:{'structure-outlet':'meeting'}}]" class="subitem"
                         (click)="activeMenu('Meetings')">

                         <span class="form-control-label custom-tooltip">
                             Meetings
                             <span class="custom-tooltiptext">
                                 View all past and upcoming meetings, add new meetings, define agenda, assign
                                 compliance tasks, publish and manage meetings </span>
                         </span>
                     </a>
                 </li>

                 <!-- Agenda Search -->
                 <li class="cat__menu-left__item"
                     [ngClass]="{'cat__menu-left__item--active': menuName === 'AgendaSearch'}"
                     *ngIf="!MeetingMakerWithoutAgenda">
                     <a [routerLink]="[{outlets:{'structure-outlet':'agendaSearch'}}]" class="subitem"
                         (click)="activeMenu('AgendaSearch')">

                         <span class="form-control-label custom-tooltip">
                             Agenda Search
                             <span class="custom-tooltiptext">
                                 Search for specific agenda items within meetings, filter by date, participants,
                                 and other criteria </span>
                         </span>
                     </a>
                 </li>

                 <!-- Templates -->
                 <li class="cat__menu-left__item"
                     [ngClass]="{'cat__menu-left__item--active': menuName === 'Templates'}"
                     *ngIf="!MeetingMakerWithoutAgenda">
                     <a [routerLink]="[{outlets:{'structure-outlet':'templates'}}]" class="subitem"
                         (click)="activeMenu('Templates')">

                         <span class="form-control-label custom-tooltip">
                             Templates
                             <span class="custom-tooltiptext">
                                 Create and manage templates for meetings, agendas, and other documents </span>
                         </span>
                     </a>
                 </li>

                 <!-- Agenda -->
                 <li class="cat__menu-left__item" [ngClass]="{'cat__menu-left__item--active': menuName === 'Agenda'}"
                     *ngIf="!MeetingMakerWithoutAgenda">
                     <a [routerLink]="[{outlets:{'structure-outlet':'agenda'}}]" class="subitem"
                         (click)="activeMenu('Agenda')">
                         Agenda
                         <!-- <span class="form-control-label custom-tooltip">
                             Agenda
                             <span class="custom-tooltiptext">
                             </span>
                         </span> -->
                     </a>
                 </li>
                 <!-- <li class="cat__menu-left__item cat__menu-left__submenu"
                     [ngClass]="{'cat__menu-left__item--active': menuName === 'Reports'}"
                     [appHasPermission]="{'Url': '', 'method':'', 'menu': 'EvaluationReports'}">
                     <a (click)="activeMenu('Reports')" class="subitem">
                         Reports
                     </a> -->
                 <!-- Tasks Submenu -->
                 <li class="cat__menu-left__item cat__menu-left__submenu"
                     [ngClass]="{'cat__menu-left__item--active': menuName === 'TaskAndActivities'}"
                     *ngIf="taskAndActivityEnable && (!MeetingMakerWithoutAgenda && !MeetingMakerWithAgenda)">

                     <a (click)="activeMenu('TaskAndActivities')">

                         <span class="form-control-label custom-tooltip">
                             Tasks
                             <span class="custom-tooltiptext">
                                 Organize, track, and manage your tasks efficiently.
                                 Assign work, set priorities, and monitor progress to ensure timely completion
                             </span>
                         </span>
                     </a>

                     <ul class="cat__menu-left__list sub-menu-list">
                         <!-- Library Tasks List -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'LibraryTaskList'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'LibraryTask'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'libraryTask'}}]" class="subitem"
                                 (click)="activeMenu('LibraryTaskList')">
                                 Library Tasks List
                             </a>
                         </li>

                         <!-- Unapproved Library Task List -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'UnapprovedLibraryTask'}"
                             *ngIf="environmentSettings?.TaskMakerChecker">
                             <a [routerLink]="[{outlets:{'structure-outlet':'unapprovedLibraryTask'}}]"
                                 class="subitem" (click)="activeMenu('UnapprovedLibraryTask')">
                                 Unapproved Library Task List
                             </a>
                         </li>

                         <!-- Activated Tasks List -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'ActivatedTaskList'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'ActivatedTaskAll'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'tasks/activated'}}]" class="subitem"
                                 (click)="activeMenu('ActivatedTaskList')">
                                 Activated Tasks List
                             </a>
                         </li>

                         <!-- Activated Tasks Kanban View -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'ActivatedTaskKanban'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'ActivatedTaskAll'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'tasks/activated/kanban'}}]"
                                 class="subitem" (click)="activeMenu('ActivatedTaskKanban')">
                                 <span class="form-control-label custom-tooltip">
                                     Activated Tasks Kanban View
                                     <span class="custom-tooltiptext">
                                         View and manage activated tasks in a Kanban board based on their status.
                                     </span>
                                 </span>
                             </a>
                         </li>
                     </ul>
                 </li>

                 <!-- Process Submenu -->
                 <li class="cat__menu-left__item cat__menu-left__submenu"
                     [ngClass]="{'cat__menu-left__item--active': menuName === 'Process'}"
                     *ngIf="processEnable && (!MeetingMakerWithoutAgenda && !MeetingMakerWithAgenda)">

                     <a (click)="activeMenu('Process')">

                         <span class="form-control-label custom-tooltip">
                             Process
                             <span class="custom-tooltiptext">
                                 The Process module is an organizational tool where you can group related tasks and
                                 activities together. It acts like a virtual folder, making workflow management
                                 easier and more structured. </span>
                         </span>
                     </a>

                     <ul class="cat__menu-left__list sub-menu-list">
                         <!-- Library Process List -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'ProcessList'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Process'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'process'}}]" class="subitem"
                                 (click)="activeMenu('ProcessList')">

                                 <span class="form-control-label custom-tooltip">
                                     Library Process List

                                     <span class="custom-tooltiptext">
                                         A process is a predefined workflow (e.g., AGM, EGM, E-Voting) containing
                                         multiple tasks.
                                         When linked with a meeting, all its tasks are automatically activated in the
                                         meeting
                                         compliance for tracking and completion. </span>
                                 </span>
                             </a>

                         </li>

                         <!-- Activated Process List -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'ActivatedProcessTasks'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'ActivatedProcessTasks'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'activatedprocess'}}]" class="subitem"
                                 (click)="activeMenu('ActivatedProcessTasks')">
                                 Activated Process List
                             </a>
                         </li>
                     </ul>
                 </li>

                 <!-- Register Submenu -->
                 <li class="cat__menu-left__item cat__menu-left__submenu"
                     [ngClass]="{'cat__menu-left__item--active': menuName === 'Process'}"
                     *ngIf="registerComplianceUser">

                     <a (click)="activeMenu('Register')">

                         <span class="form-control-label custom-tooltip">
                             Digi Register
                             <span class="custom-tooltiptext">
                                 Use the Register module to maintain and manage all key organizational records
                                 efficiently.Track entries across Directors, KMP, Management, Shareholders, Deposits,
                                 and
                                 other statutory areas.Ensure proper documentation, compliance, and easy access for
                                 audits or
                                 reporting </span>
                         </span>

                     </a>

                     <ul class="cat__menu-left__list sub-menu-list"
                         *ngIf="(!MeetingMakerWithoutAgenda && !MeetingMakerWithAgenda)">
                         <!-- Director -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'Director'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Director'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'director'}}]" class="subitem"
                                 (click)="activeMenu('Director')">
                                 Director
                             </a>
                         </li>

                         <!-- KMP -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'KMP'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'KMP'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'KMP'}}]" class="subitem"
                                 (click)="activeMenu('KMP')">
                                 KMP
                             </a>
                         </li>

                         <!-- Other register items... -->
                         <!-- MGT-1 -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'mgt1list'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'mgt1list'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'mgt1'}}]" class="subitem"
                                 (click)="activeMenu('mgt1list')">
                                 MGT - 1
                             </a>
                         </li>

                         <!-- MGT-2 -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'mgt2List'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'mgt2List'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'mgt2'}}]" class="subitem"
                                 (click)="activeMenu('mgt2List')">
                                 MGT - 2
                             </a>
                         </li>

                         <!-- BEN-3 -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'Ben3'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Ben3'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'ben3list'}}]" class="subitem"
                                 (click)="activeMenu('Ben3')">
                                 BEN - 3
                             </a>
                         </li>

                         <!-- SH-2 -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'sh2List'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'sh2List'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'sh2list'}}]" class="subitem"
                                 (click)="activeMenu('sh2List')">
                                 SH - 2
                             </a>
                         </li>

                         <!-- SH-3 -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'sh3List'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'sh3List'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'sh3list'}}]" class="subitem"
                                 (click)="activeMenu('sh3List')">
                                 SH - 3
                             </a>
                         </li>

                         <!-- SH-6 -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'mastersh6'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'mastersh6'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'sh6list'}}]" class="subitem"
                                 (click)="activeMenu('mastersh6')">
                                 SH - 6
                             </a>
                         </li>

                         <!-- SH-10 -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'mastersh10list'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'mastersh10list'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'sh10list'}}]" class="subitem"
                                 (click)="activeMenu('mastersh10list')">
                                 SH - 10
                             </a>
                         </li>

                         <!-- Deposit -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'depositorList'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'depositorList'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'depositorList'}}]" class="subitem"
                                 (click)="activeMenu('depositorList')">
                                 Deposit
                             </a>
                         </li>

                         <!-- CHG-7 -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'chg7List'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'chg7List'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'chg7List'}}]" class="subitem"
                                 (click)="activeMenu('chg7List')">
                                 CHG - 7
                             </a>
                         </li>

                         <!-- MBP-2 -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'mbp2List'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'mbp2List'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'mbp2List'}}]" class="subitem"
                                 (click)="activeMenu('mbp2List')">
                                 MBP - 2
                             </a>
                         </li>

                         <!-- MBP-3 -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'mbp3List'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'mbp3List'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'mbp3List'}}]" class="subitem"
                                 (click)="activeMenu('mbp3List')">
                                 MBP - 3
                             </a>
                         </li>

                         <!-- MBP-4A -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'mbp4aList'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'mbp4List'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'mbp4aList'}}]" class="subitem"
                                 (click)="activeMenu('mbp4aList')">
                                 MBP - 4A
                             </a>
                         </li>

                         <!-- MBP-4B -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'mbp4bList'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'mbp4bList'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'mbp4bList'}}]" class="subitem"
                                 (click)="activeMenu('mbp4bList')">
                                 MBP - 4B
                             </a>
                         </li>

                         <!-- Inspection -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'Inspection'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Inspection'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'inspectionList'}}]" class="subitem"
                                 (click)="activeMenu('Inspection')">
                                 Inspection
                             </a>
                         </li>

                         <!-- Proxy -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'proxy'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Proxy'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'proxyList'}}]" class="subitem"
                                 (click)="activeMenu('proxy')">
                                 Proxy
                             </a>
                         </li>

                         <!-- Bank Account Particulars -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'masterbankparticulars'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'masterbankparticulars'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'masterbankparticulars'}}]"
                                 class="subitem" (click)="activeMenu('masterbankparticulars')">
                                 Bank Account Particulars
                             </a>
                         </li>

                         <!-- Power of Attorney -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'powerofattorney'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'powerofattorney'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'powerofattorneylist'}}]" class="subitem"
                                 (click)="activeMenu('powerofattorney')">
                                 Power of Attorney
                             </a>
                         </li>

                         <!-- Payment of Dividend -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'paymentOfDividend'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'paymentOfDividend'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'paymentOfDividendList'}}]"
                                 class="subitem" (click)="activeMenu('paymentOfDividend')">
                                 Payment of Dividend
                             </a>
                         </li>

                         <!-- Investments -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'investment'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'investment'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'investment-list'}}]" class="subitem"
                                 (click)="activeMenu('investment')">
                                 Investments
                             </a>
                         </li>

                         <!-- Electronic Clearing Service (ECS) -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'ecslist'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'ecslist'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'ecslist'}}]" class="subitem"
                                 (click)="activeMenu('ecslist')">
                                 Electronic Clearing Service (ECS)
                             </a>
                         </li>

                         <!-- Documents Executed under Common Seal -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'commonSeal'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'commonSeal'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'documentundercommonseallist'}}]"
                                 class="subitem" (click)="activeMenu('commonSeal')">
                                 Documents Executed under Common Seal
                             </a>
                         </li>

                         <!-- Investor Complaints -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'Masterinvestorcomplaints'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Masterinvestorcomplaints'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'masterinvestorcomplaints'}}]"
                                 class="subitem" (click)="activeMenu('Masterinvestorcomplaints')">
                                 Investor Complaints
                             </a>
                         </li>

                         <!-- Dividend Mandate -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'dividendMandateList'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'dividendMandateList'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'dividendMandateList'}}]" class="subitem"
                                 (click)="activeMenu('dividendMandateList')">
                                 Dividend Mandate
                             </a>
                         </li>

                         <!-- Postal Ballot -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'postallballotlist'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'postallballotlist'}">
                             <a [routerLink]="[{outlets:{'structure-outlet':'postallballotlist'}}]" class="subitem"
                                 (click)="activeMenu('postallballotlist')">
                                 Postal Ballot
                             </a>
                         </li>

                     </ul>

                     <!-- Meeting Maker version of Register -->
                     <ul class="cat__menu-left__list sub-menu-list"
                         *ngIf="(MeetingMakerWithoutAgenda || MeetingMakerWithAgenda)">
                         <!-- Director -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'Director'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Director'}">
                             <a href="{{menuLinkObject.Director}}" class="subitem" (click)="activeMenu('Director')">
                                 Director
                             </a>
                         </li>

                         <!-- KMP -->
                         <li class="cat__menu-left__item"
                             [ngClass]="{'cat__menu-left__item--active': menuName === 'KMP'}"
                             [appHasPermission]="{'Url': '', 'method':'', 'menu': 'KMP'}">
                             <a href="{{menuLinkObject.KMP}}" class="subitem" (click)="activeMenu('KMP')">
                                 KMP
                             </a>
                         </li>
                     </ul>
                 </li>
             </ul>
         </li>
            <!-- Board Evaluation-->

            <li class="cat__menu-left__item cat__menu-left__submenu "
                *ngIf="boardEvaluationMenuEnable && (isBoardEvaluationConfig) && !isUPSILiteActive">
                <a *ngIf="isGovernance" (click)="activeMenu('Board Entity')" href="javascript: void(0);">
                    Materiality
                </a>
                <a *ngIf="!isGovernance" (click)="activeMenu('Board Entity')" href="javascript: void(0);">
                    <span class="material-symbols-outlined">checklist</span>
                    Evaluation
                </a>
                <ul class="cat__menu-left__list sub-menu-list">
                    <li class="cat__menu-left__item cat__menu-left__submenu " *ngIf="isEvaluationMasterEnable"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'BoardEvaluationMaster'}">
                        <a (click)="activeMenu('BoardEvaluationMaster')" class="subitem">
                            Evaluation Master
                        </a>
                        <ul class="cat__menu-left__list sub-menu-list">
                            <li class="cat__menu-left__item" (click)="activeMenu('Evaluation Entity')"
                                [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationType/getAllEvaluationType', 'method':'get', 'menu': 'EvaluationType'}"
                                [ngClass]="{'cat__menu-left__item--active': menuName === 'Evaluation Entity'}">
                                <a [routerLink]="[{outlets:{'structure-outlet':'entityMaster'}}]" class="subitem">

                                    <span class="form-control-label custom-tooltip">
                                        Entity
                                        <span class="custom-tooltiptext">
                                            Define and manage entities to be evaluated (department, team, individuals
                                            etc).
                                        </span>
                                    </span>

                                </a>


                            </li>
                            <li class="cat__menu-left__item" (click)="activeMenu('Evaluate Criteria')"
                                [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationCriteria/getAllEvaluationCriteria', 'method':'get', 'menu': 'EvaluationCriteria'}"
                                [ngClass]="{'cat__menu-left__item--active': menuName === 'Evaluate Criteria'}">
                                <a [routerLink]="[{outlets:{'structure-outlet':'evaluateCategory'}}]" class="subitem">


                                    <span class="form-control-label custom-tooltip">
                                        Criteria
                                        <span class="custom-tooltiptext">
                                            Evaluation to be based on criterions to assess the performance of entity.
                                        </span>
                                    </span>
                                </a>
                            </li>
                            <li class="cat__menu-left__item"
                                [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationQuestion/getAllEvaluationQuestion', 'method':'get', 'menu': 'EvaluationQuestion'}"
                                [ngClass]="{'cat__menu-left__item--active': menuName === 'QuestionMaster'}">
                                <a [routerLink]="[{outlets:{'structure-outlet':'questionMasterBoardEval'}}]"
                                    class="subitem" (click)="activeMenu('QuestionMaster')">
                                    <span class="form-control-label custom-tooltip">

                                        <span class="form-control-label custom-tooltip">
                                            Question Master
                                            <span class="custom-tooltiptext">
                                                Library of questions that can be used for evaluations.
                                            </span>
                                        </span>
                                    </span>
                                </a>
                            </li>
                            <li class="cat__menu-left__item" (click)="activeMenu('Evaluate Questionnaire Setup')"
                                [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationFormSetup/getAllEvaluationFormSetup', 'method':'get', 'menu': 'EvaluationFormSetup'}"
                                [ngClass]="{'cat__menu-left__item--active': menuName === 'Evaluate Questionnaire Setup'}">
                                <a [routerLink]="[{outlets:{'structure-outlet':'evaluateFormSetup'}}]" class="subitem">

                                    <span class="form-control-label custom-tooltip">
                                        Questionnaire Setup
                                        <span class="custom-tooltiptext">
                                            Set up customised questionnaires for evaluation.
                                        </span>
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li class="cat__menu-left__item" (click)="activeMenu('EvaluationQuestionnaire')"
                        [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationBank/viewboardEvaluationBank', 'method':'get', 'menu': 'QuestionnaireBank'}"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'EvaluationQuestionnaire'}">
                        <a [routerLink]="[{outlets:{'structure-outlet':'evaluationForms'}}]" class="subitem">
                            <span class="form-control-label custom-tooltip">
                                Questionnaire Bank
                                <span class="custom-tooltiptext">
                                    View and manage the collection of all saved questionnaires for future evaluations.
                                </span>
                            </span>
                        </a>
                    </li>

                    <li class="cat__menu-left__item" (click)="activeMenu('QuestionnaireReview')"
                        [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationFormReview/getAllEvaluationFormReview', 'method':'get', 'menu': 'EvaluationFormReview'}"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'QuestionnaireReview'}">
                        <a [routerLink]="[{outlets:{'structure-outlet':'evaluationReview'}}]" class="subitem">


                            <span class="form-control-label custom-tooltip">
                                Questionnaire Review

                                <span class="custom-tooltiptext">
                                    Review and verify questionnaires before assigning for evaluation.
                                </span>
                            </span>
                        </a>
                    </li>
                    <li class="cat__menu-left__item" (click)="activeMenu('Evaluation Monitoring')"
                        [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationFormMonitoring/getAllEvaluationFormMonitoring', 'method':'get', 'menu': 'EvaluationFormMonitoring'}"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Evaluation Monitoring'}">
                        <a [routerLink]="[{outlets:{'structure-outlet':'evaluationMonitoring'}}]" class="subitem">

                            <span class="form-control-label custom-tooltip">
                                Evaluation Management And Monitoring
                                <span class="custom-tooltiptext">
                                    Manage ongoing & past evaluations and monitor their progress in real time. </span>
                            </span>
                        </a>
                    </li>
                    <li class="cat__menu-left__item" (click)="activeMenu('assignedEvaluationFormList')"
                        [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationFormExecution/getAllEvaluationFormExecution', 'method':'get', 'menu': 'EvaluationFormExecution'}"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'assignedEvaluationFormList'}">
                        <a [routerLink]="[{outlets:{'structure-outlet':'evaluationFormList'}}]" class="subitem">

                            <span class="form-control-label custom-tooltip">
                                Answer and Submission
                                <span class="custom-tooltiptext">
                                    Submit responses to questionnaires and track completion status. </span>
                            </span>
                        </a>
                    </li>
                    <li class="cat__menu-left__item cat__menu-left__submenu"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Reports'}"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'EvaluationReports'}">
                        <a (click)="activeMenu('Reports')" class="subitem">
                            Reports
                        </a>
                        <ul class="cat__menu-left__list sub-menu-list">

                            <li class="cat__menu-left__item"
                                [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationReports/getDetailedReport', 'method':'get', 'menu': 'EvaluationReports'}"
                                [ngClass]="{'cat__menu-left__item--active': menuName === 'Individual Report List'}">
                                <a [routerLink]="[{outlets:{'structure-outlet':'individualReportList'}}]"
                                    class="subitem">
                                    <span class="form-control-label custom-tooltip">
                                        Detailed Report
                                        <span class="custom-tooltiptext">
                                            View in-depth evaluation results with question-wise and criteria-wise
                                            breakdowns.</span>
                                    </span>

                                </a>
                            </li>
                            <li class="cat__menu-left__item"
                                [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationReports/getSummaryReport', 'method':'get', 'menu': 'EvaluationReports'}"
                                [ngClass]="{'cat__menu-left__item--active': menuName === ' Summary Report'}">
                                <a [routerLink]="[{outlets:{'structure-outlet':'summaryReport'}}]" class="subitem">
                                    <span class="form-control-label custom-tooltip">
                                        Summary Report
                                        <span class="custom-tooltiptext">
                                            View a high-level summary of evaluation results for quick insights. </span>
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </li>

                </ul>
            </li>

            <!-- Risk Evaluation    -->

            <li class="cat__menu-left__item cat__menu-left__submenu "
                *ngIf="boardEvaluationMenuEnable && (isBoardEvaluationConfig) && !isUPSILiteActive">
                <a *ngIf="isGovernance" (click)="activeMenu('Board Entity')" href="javascript: void(0);">
                    Materiality
                </a>
                <a *ngIf="!isGovernance" (click)="activeMenu('Board Entity')" href="javascript: void(0);">
                    <span class="material-symbols-outlined">earthquake</span>
                    Risk Evaluation
                </a>
                <ul class="cat__menu-left__list sub-menu-list">
                    <li class="cat__menu-left__item cat__menu-left__submenu " *ngIf="isEvaluationMasterEnable"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'BoardEvaluationMaster'}">
                        <a (click)="activeMenu('BoardEvaluationMaster')" class="subitem">
                            Evaluation Master
                        </a>
                        <ul class="cat__menu-left__list sub-menu-list">
                            <li class="cat__menu-left__item" (click)="activeMenu('Evaluation Entity')"
                                [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationType/getAllEvaluationType', 'method':'get', 'menu': 'EvaluationType'}"
                                [ngClass]="{'cat__menu-left__item--active': menuName === 'Evaluation Entity'}">
                                <a [routerLink]="[{outlets:{'structure-outlet':'riskEntityMaster'}}]" class="subitem">
                                    Entity
                                </a>
                            </li>
                            <li class="cat__menu-left__item" (click)="activeMenu('Evaluate Criteria')"
                                [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationCriteria/getAllEvaluationCriteria', 'method':'get', 'menu': 'EvaluationCriteria'}"
                                [ngClass]="{'cat__menu-left__item--active': menuName === 'Evaluate Criteria'}">
                                <a [routerLink]="[{outlets:{'structure-outlet':'riskEvaluateCategory'}}]"
                                    class="subitem">
                                    Risk Description
                                </a>
                            </li>
                            <li class="cat__menu-left__item" (click)="activeMenu('Evaluate Department')"
                                [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationCriteria/getAllEvaluationCriteria', 'method':'get', 'menu': 'EvaluationCriteria'}"
                                [ngClass]="{'cat__menu-left__item--active': menuName === 'Evaluate Criteria'}">
                                <a [routerLink]="[{outlets:{'structure-outlet':'riskDepartment'}}]" class="subitem">
                                    Risk Department
                                </a>
                            </li>
                            <li class="cat__menu-left__item" (click)="activeMenu('Evaluate Matrix')"
                                [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationCriteria/getAllEvaluationCriteria', 'method':'get', 'menu': 'EvaluationCriteria'}"
                                [ngClass]="{'cat__menu-left__item--active': menuName === 'Evaluate Criteria'}">
                                <a [routerLink]="[{outlets:{'structure-outlet':'riskMatrix'}}]" class="subitem">
                                    Risk Matrix
                                </a>
                            </li>
                            <li class="cat__menu-left__item"
                                [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationQuestion/getAllEvaluationQuestion', 'method':'get', 'menu': 'EvaluationQuestion'}"
                                [ngClass]="{'cat__menu-left__item--active': menuName === 'QuestionMaster'}">
                                <a [routerLink]="[{outlets:{'structure-outlet':'riskQuestionMasterBoardEval'}}]"
                                    class="subitem" (click)="activeMenu('QuestionMaster')">
                                    <span class="form-control-label custom-tooltip">
                                        Question Master
                                    </span>
                                </a>
                            </li>
                            <li class="cat__menu-left__item" (click)="activeMenu('Evaluate Questionnaire Setup')"
                                [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationFormSetup/getAllEvaluationFormSetup', 'method':'get', 'menu': 'EvaluationFormSetup'}"
                                [ngClass]="{'cat__menu-left__item--active': menuName === 'Evaluate Questionnaire Setup'}">
                                <a [routerLink]="[{outlets:{'structure-outlet':'riskEvaluateFormSetup'}}]"
                                    class="subitem">
                                    Questionnaire Setup
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li class="cat__menu-left__item" (click)="activeMenu('EvaluationQuestionnaire')"
                        [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationBank/viewboardEvaluationBank', 'method':'get', 'menu': 'QuestionnaireBank'}"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'EvaluationQuestionnaire'}">
                        <a [routerLink]="[{outlets:{'structure-outlet':'riskEvaluationForms'}}]" class="subitem">
                            Questionnaire Bank
                        </a>
                    </li>

                    <li class="cat__menu-left__item" (click)="activeMenu('QuestionnaireReview')"
                        [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationFormReview/getAllEvaluationFormReview', 'method':'get', 'menu': 'EvaluationFormReview'}"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'QuestionnaireReview'}">
                        <a [routerLink]="[{outlets:{'structure-outlet':'riskEvaluationReview'}}]" class="subitem">
                            Questionnaire Review
                        </a>
                    </li>
                    <li class="cat__menu-left__item" (click)="activeMenu('Evaluation Monitoring')"
                        [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationFormMonitoring/getAllEvaluationFormMonitoring', 'method':'get', 'menu': 'EvaluationFormMonitoring'}"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Evaluation Monitoring'}">
                        <a [routerLink]="[{outlets:{'structure-outlet':'riskEvaluationMonitoring'}}]" class="subitem">
                            Evaluation Management And Monitoring
                        </a>
                    </li>
                    <li class="cat__menu-left__item" (click)="activeMenu('assignedEvaluationFormList')"
                        [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationFormExecution/getAllEvaluationFormExecution', 'method':'get', 'menu': 'EvaluationFormExecution'}"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'assignedEvaluationFormList'}">
                        <a [routerLink]="[{outlets:{'structure-outlet':'riskEvaluationFormList'}}]" class="subitem">
                            Answer and Submission
                        </a>
                    </li>
                    <li class="cat__menu-left__item cat__menu-left__submenu"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Reports'}"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'EvaluationReports'}">
                        <a (click)="activeMenu('Reports')" class="subitem">
                            Reports
                        </a>
                        <ul class="cat__menu-left__list sub-menu-list">

                            <li class="cat__menu-left__item"
                                [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationReports/getDetailedReport', 'method':'get', 'menu': 'EvaluationReports'}"
                                [ngClass]="{'cat__menu-left__item--active': menuName === 'Individual Report List'}">
                                <a [routerLink]="[{outlets:{'structure-outlet':'riskIndividualReportList'}}]"
                                    class="subitem">
                                    <span class="form-control-label custom-tooltip">
                                        Detailed Report
                                    </span>
                                </a>
                            </li>
                            <li class="cat__menu-left__item"
                                [appHasPermission]="{'Url': '/api/v1/secure/boardEvaluationReports/getSummaryReport', 'method':'get', 'menu': 'EvaluationReports'}"
                                [ngClass]="{'cat__menu-left__item--active': menuName === ' Summary Report'}">
                                <a [routerLink]="[{outlets:{'structure-outlet':'riskSummaryReport'}}]" class="subitem">
                                    <span class="form-control-label custom-tooltip">
                                        Summary Report
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </li>

                </ul>
            </li>

           

            <!-- Compliance Certificate -->

            <li class="cat__menu-left__item cat__menu-left__submenu "
                [ngClass]="{'customMenuLeftInActive': menuName !== 'Compliance', 'customMenuLeftActive': menuName === 'Compliance'}"
                *ngIf="complianceMenuEnable && (isAllConfig || isPSSConfig) && FinalMenu.Complaince && !isUPSILiteActive">

                <a href="javascript: void(0);" (click)="activeMenu('Certificate')">
                    <span class="material-symbols-outlined">license</span>
                    Compliance Certificate
                </a>
                <ul class="cat__menu-left__list sub-menu-list">

                    <li class="cat__menu-left__item" (click)="activeMenu('complianceItem')"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'complianceItem'}" *ngIf="true">
                        <a class="subitem" [routerLink]="[{outlets:{'structure-outlet':'complianceItem'}}]">
                            Compliance Item
                        </a>
                    </li>

                    <li class="cat__menu-left__item" (click)="activeMenu('complianceCertificateList')"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'complianceCertificateList'}"
                        *ngIf="true">
                        <a class="subitem" [routerLink]="[{outlets:{'structure-outlet':'complianceCertificateList'}}]">
                            Compliance Certificate Library
                        </a>
                    </li>

                    <li class="cat__menu-left__item" (click)="activeMenu('activatedComplianceCertificate')"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'activatedComplianceCertificate'}"
                        *ngIf="true">
                        <a class="subitem"
                            [routerLink]="[{outlets:{'structure-outlet':'activatedComplianceCertificate'}}]">
                            <span class="cat__menu-left__icon"></span>
                            Activated Compliance Certificate
                        </a>
                    </li>

                </ul>
            </li>

            <!-- UPSI Menu -->
            <li class="cat__menu-left__item cat__menu-left__submenu"
                [ngClass]="{'customMenuLeftInActive': menuName !== 'upsi', 'customMenuLeftActive': menuName === 'upsi'}"
                *ngIf="!isSuperAdmin && isUPSIConfig && upsiMenu && FinalMenu.UPSI">
                <a (click)="activeMenu('upsi')" href="javascript: void(0);">
                    <span class="material-symbols-outlined">folder_eye</span>
                    UPSI
                </a>
                <ul class="cat__menu-left__list sub-menu-list">
                    <!-- Keep all UPSI menu items here -->
                    <!-- <li class="cat__menu-left__item"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'upsiSharer'}"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'UPSI Sharer'}">
                        <a [routerLink]="[{outlets:{'structure-outlet':'userMaster/upsisharer'}}]" class="subitem">
                            <span class="form-control-label custom-tooltip">
                                UPSI Sharer
                                <span class="custom-tooltiptext">
                                    Add and manage users or employees who are responsible for sharing Unpublished Price
                                    Sensitive Information (UPSI) within the organization.
                                </span>
                            </span>
                        </a>
                    </li> -->


                    <!-- <li class="cat__menu-left__item"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'upsiRecipient'}"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'UPSI Recipient'}">
                        <a [routerLink]="[{outlets:{'structure-outlet':'userMaster/upsirecipient'}}]" class="subitem">


                            <span class="form-control-label custom-tooltip">
                                UPSI Recipient
                                <span class="custom-tooltiptext">
                                    Track and manage users or external parties who receive Unpublished Price Sensitive
                                    Information (UPSI) for compliance purposes
                                </span>
                            </span>
                        </a>
                    </li> -->

                    <li class="cat__menu-left__item"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'upsiDetails'}"
                        *ngIf="UPSIDetailMenuEnable">
                        <a [routerLink]="[{outlets:{'structure-outlet':'userMaster/upsidetails'}}]" class="subitem">

                            <span class="form-control-label custom-tooltip">
                                UPSI Details
                                <span class="custom-tooltiptext">
                                    Record and maintain detailed information about each UPSI event, including date,
                                    description, and involved parties
                                </span>
                            </span>
                        </a>
                    </li>
                    <li class="cat__menu-left__item"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'upsibulkdata'}"
                        *ngIf="UPSIBulkDataMenuEnable && !isUPSILiteActive">
                        <a [routerLink]="[{outlets:{'structure-outlet':'userMaster/upsibulkdata'}}]" class="subitem">

                            <span class="form-control-label custom-tooltip">
                                UPSI Bulk Data
                                <span class="custom-tooltiptext">
                                    Easily upload and manage multiple UPSI records at once to save time and ensure
                                    accurate compliance reporting </span>
                            </span>
                        </a>
                    </li>
                    <li class="cat__menu-left__item"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'upsiEmailsLog'}">
                        <a [routerLink]="[{outlets:{'structure-outlet':'userMaster/upsiEmailsLog'}}]" class="subitem">

                            <span class="form-control-label custom-tooltip">
                                UPSI Email Log
                                <span class="custom-tooltiptext">
                                    View and track all email communications related to UPSI sharing for auditing and
                                    compliance purposes. </span>
                            </span>
                        </a>
                    </li>
                    <li class="cat__menu-left__item" *ngIf="isUPSIConfig && upsiEmailMenuEnable"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Email Template UPSI'}"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Email Template'}">
                        <a href="{{menuLinkObject.EmailTemplatesCompliance}}" class="subitem"
                            (click)="activeMenu('Email Template UPSI')">
                            Email Templates
                        </a>
                    </li>
                </ul>
            </li>

            <!-- NCD Menu -->
            <li class="cat__menu-left__item cat__menu-left__submenu"
                [ngClass]="{'customMenuLeftInActive': menuName !== 'ncd', 'customMenuLeftActive': menuName === 'ncd'}"
                *ngIf="!isSuperAdmin && isNCDConfig && ncdMenu && FinalMenu.NCD && !isUPSILiteActive">
                <a (click)="activeMenu('ncd')" href="javascript: void(0);">
                    <span class="material-symbols-outlined">shield_lock</span>
                    NCD
                </a>
                <ul class="cat__menu-left__list sub-menu-list">
                    <!-- Keep all NCD menu items here -->
                    <li class="cat__menu-left__item"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'NCD-issueList'}">
                        <a [routerLink]="[{outlets:{'structure-outlet':'ncdIssuesList'}}]" class="subitem">

                            <!-- <a class="subitem"   href="{{menuLinkObject.ncdIssuesList}}" [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Term Sheet'}">-->
                            Term Sheet
                        </a>
                    </li>
                    <li class="cat__menu-left__item" (click)="activeMenu('Termsheet Library')"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Termsheet Library'}">
                        <a [routerLink]="[{outlets:{'structure-outlet':'termsheetLibrary'}}]" class="subitem">

                            <!-- <a class="subitem"  href="{{menuLinkObject.ncdLibrary}}" [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Term Sheet Library'}"> -->
                            Term Sheet Library
                        </a>
                    </li>

                    <li class="cat__menu-left__item" (click)="activeMenu('Allottees Library')"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Allottees Library'}">
                        <a [routerLink]="[{outlets:{'structure-outlet':'allotteesLibrary'}}]" class="subitem">
                            <!-- <a class="subitem"   href="{{menuLinkObject.ncdAllotteesLibrary}}" [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Allottees Library'}"> -->
                            Allottees Library
                        </a>
                    </li>
                </ul>
            </li>

            <!-- Admin Menu -->
            <li class="cat__menu-left__item cat__menu-left__submenu"
                [ngClass]="{'customMenuLeftInActive': menuName !== 'Admin', 'customMenuLeftActive': menuName === 'Admin'}"
                *ngIf="masterMenuEnable && FinalMenu.Admin">
                <a (click)="activeMenu('Admin')" href="javascript: void(0);">
                    <span class="material-symbols-outlined">admin_panel_settings</span>
                    Admin
                </a>
                <ul class="cat__menu-left__list sub-menu-list">
                    <!-- Keep all Admin menu items here -->
                    <li class="cat__menu-left__item" (click)="activeMenu('Admin')"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Audit Trail'}"
                        [appHasPermission]="{'Url': '', 'method':'', 'menu': 'Admin'}" *ngIf="auditTrailEnable">
                        <a [routerLink]="[{outlets:{'structure-outlet':'auditTrail'}}]" class="subitem">
                            Audit Trail & Database Back up
                        </a>
                    </li>
                    <!-- </ul> -->
                    <!-- for smtp -->
                    <!-- <ul class="cat__menu-left__list sub-menu-list"> -->
                    <li class="cat__menu-left__item" (click)="activeMenu('Admin')"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Audit Trail'}">
                        <a [routerLink]="[{outlets:{'structure-outlet':'conmpany-config'}}]" class="subitem">
                            Company Config
                        </a>
                    </li>
                    
                    <!-- UPSI Subscription Settings -->
                    <li class="cat__menu-left__item" (click)="activeMenu('UPSI Subscription Settings')"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'UPSI Subscription Settings'}"
                        *ngIf="isUPSIConfig && isGuestSuperAdmin">
                        <a [routerLink]="[{outlets:{'structure-outlet':'admin-upsisubscriptionsettings'}}]" class="subitem">
                            <span class="form-control-label custom-tooltip">
                                UPSI Subscription Settings
                                <span class="custom-tooltiptext">
                                    Configure and toggle between UPSI Main and UPSI Lite subscriptions to control available features
                                </span>
                            </span>
                        </a>
                    </li>
                    
                    <!-- </ul> -->
                    <!-- <ul class="cat__menu-left__list sub-menu-list"> -->
                    <li *ngIf="false" class="cat__menu-left__item" (click)="activeMenu('Admin')"
                        [ngClass]="{'cat__menu-left__item--active': menuName === 'Audit Trail'}">
                        <a [routerLink]="[{outlets:{'structure-outlet':'data-import'}}]" class="subitem">
                            Data Import
                        </a>
                    </li>
                </ul>
            </li>

            <!-- Laws & Regulations Menu -->
            <li class="cat__menu-left__item cat__menu-left--colorful--primary"
                (click)="activeMenu('complianceRegulations')"
                [ngClass]="{'cat__menu-left__item--active': menuName === 'complianceRegulations'}"
                *ngIf="lawAndRegulationMenuEnable && FinalMenu.Laws && !isUPSILiteActive">
                <a [routerLink]="[{outlets:{'structure-outlet':'compliance'}}]">
                    <span class="material-symbols-outlined">gavel</span>

                    <span class="form-control-label custom-tooltip">
                        Laws & Regulations
                        <span class="custom-tooltiptext">
                            Access important legal <br> frameworks
                            and regulatory guidelines including Companies Act, SEBI norms, Secretarial Standards, and
                            other compliance-related provisions.
                        </span>
                    </span>

                </a>
            </li>



            <!-- Digi File Manager Menu -->
            <li *ngIf="isGEMConfig && FinalMenu.File && !isUPSILiteActive" class="cat__menu-left__item cat__menu-left__menu"
                (click)="activeMenu('GFMDashboard')"
                [ngClass]="{'cat__menu-left__item--active': menuName === 'GFMDashboard'}">
                <a [routerLink]="[{outlets:{'structure-outlet':'gfmDashboard'}}]"
                    [queryParams]="{ isCompliance : 'false' }">
                    <span class="material-symbols-outlined">cloud_upload</span>
                    Digi File Manager
                </a>
            </li>
            <!-- Payroll Menu -->
            <li class="cat__menu-left__item cat__menu-left--colorful--primary" (click)="activeMenu('payroll')"
                [ngClass]="{'cat__menu-left__item--active': menuName === 'payroll'}"
                *ngIf="payrollMenuEnable && FinalMenu.Payroll && !isUPSILiteActive">
                <a href="https://payroll.digicompany.in/" target="_blank" rel="noopener noreferrer">
                <!-- <a href="https://digicompany.in/contact"> -->

                    <span class="material-symbols-outlined">payments</span>

                    <span class="form-control-label custom-tooltip">
                        DigiCompany Payroll
                        <span class="custom-tooltiptext">
                            Access your payroll data and manage your employees' salaries and benefits.
                        </span>
                    </span>

                </a>
            </li>
        </ul>
        <!-- Sidebar footer: copyright & version (moved from page footer) -->
        <div class="sidebar-footer">
            <div class="sidebar-footer__copyright">
                <span>Copyright © {{ currentYear }}, All rights reserved</span>
            </div>
            <div class="sidebar-footer__version">
                <span>Version 3.1.2 (M-CIE-27042026)</span>
            </div>
        </div>
    </div>
</nav>